function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M19.307 2.687v14.625a1.995 1.995 0 0 1-1.994 1.995h-3.545v-7.363h2.518l.362-2.808h-2.88V7.34c0-.814.225-1.367 1.392-1.367h1.488v-2.51a19.998 19.998 0 0 0-2.17-.112c-2.143 0-3.614 1.309-3.614 3.715V9.14H8.338v2.809h2.53v7.358h-8.18a1.995 1.995 0 0 1-1.995-1.994V2.687c0-1.1.893-1.994 1.994-1.994h14.625c1.102 0 1.995.893 1.995 1.994z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  fill: "#3B5DA7",
  fillRule: "evenodd",
  xlinkHref: "#a"
});

var SvgIconFbBlue = function SvgIconFbBlue(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFbBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-fb-blue.7cb8f15b.svg";
export { ForwardRef as ReactComponent };